import React, { useEffect, useRef, useState } from "react"
import { DotsType } from ".";
import { IconVariant } from "../../types/icons";
import { H4 } from "../Typography";
import { DotsWrapper, PaginationSpacer, ProgressBarContainer, ProgressBarDot, ProgressBarProgress, ProgressBarProgressWrapper, ProgressBarWrapper } from "./ProgressPagination.styles"

type ProgressPaginationProps = {
    numberSlides: number
    activeIndex?: number
    onSelectIndex: (number: number) => void
    transitionDelay: number
    transitionDuration: number
    dotComponents: DotsType,
    paginationWidth: number,
    shrinkLength: number,
    autoplayRunning?: boolean,
    lastElementWidth: number,
}

export const ProgressPagination = ({
    numberSlides,
    activeIndex = 0,
    onSelectIndex,
    transitionDelay,
    transitionDuration,
    dotComponents,
    paginationWidth,
    shrinkLength,
    autoplayRunning = false,
    lastElementWidth
}: ProgressPaginationProps) => {

    let dots = Array.from(Array(numberSlides).keys());

    const [width, setWidth] = useState(0);
    const itemsRef = useRef<(HTMLDivElement | null)[]>([]);
    const containerRef = useRef<HTMLDivElement>(null);
    const paginationTranslationBreakpoint = paginationWidth + 150;
    const anchorPoint = typeof window !== 'undefined' && window && window.innerWidth > 600 ? 300 : 120;

    useEffect(() => {
        let width: number;

        if (autoplayRunning) {
            width = (activeIndex + 1) / (numberSlides - 1);
        } else {
            width = activeIndex / (numberSlides - 1);
        }

        setWidth(Math.min(99, Math.min(width * 100, 100)));

        const dotElem = itemsRef.current[activeIndex];

        if (dotElem) {
            updateTranslate(dotElem);
        }

    }, [activeIndex, transitionDuration]);

    const updateTranslate = (elem: HTMLDivElement) => {
        const left = elem.getBoundingClientRect().left;

        if (window.innerWidth < paginationTranslationBreakpoint) {
            let distanceFromAnchor = 0;

            if (left > anchorPoint) {
                distanceFromAnchor = left - anchorPoint;
            } else {
                distanceFromAnchor = Math.abs(left - anchorPoint) * -1;
            }

            if (containerRef.current && containerRef.current.scrollBy) {
                containerRef.current.scrollBy({
                    left: distanceFromAnchor,
                    behavior: "smooth"
                });
            }
        }
    }

    return <ProgressBarContainer widthLength={paginationTranslationBreakpoint} ref={containerRef}>
        <ProgressBarWrapper widthLength={paginationWidth} shrinkLength={shrinkLength}>
            <ProgressBarProgressWrapper>
                <ProgressBarProgress
                    width={width}
                    activeIndex={activeIndex}
                    animationEnabled={autoplayRunning}
                    transitionDelay={transitionDelay + 50}
                    transitionDuration={transitionDuration}
                />
            </ProgressBarProgressWrapper>
            {
                dots.map((slideNumber, index) => {
                    const iconPath = dotComponents[index].icon;
                    const isActive = activeIndex === slideNumber;

                    return <ProgressBarDot
                        key={slideNumber}
                        ref={el => {
                            itemsRef.current[index] = el;
                            return undefined;
                        }}
                        active={activeIndex >= slideNumber}
                        onClick={() => {
                            onSelectIndex(slideNumber);
                        }}
                    >
                        <DotsWrapper active={isActive} widthLength={paginationTranslationBreakpoint} >
                            <div>
                                <img src={`/authory_static_files/images/icons/${iconPath}_xs_${isActive ? IconVariant.Active : IconVariant.Disabled}.svg`} />
                            </div>
                            <H4 semibold>{dotComponents[index].text}</H4>
                        </DotsWrapper>
                    </ProgressBarDot>
                })
            }
        </ProgressBarWrapper>
        <PaginationSpacer widthLength={paginationTranslationBreakpoint} lastElementWidth={lastElementWidth} />
    </ProgressBarContainer>
}